import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { Html5QrcodeResult } from 'html5-qrcode';
import { useEffect, useState } from 'react';
import BarcodeScanner from '../scanner/scanner-input';
import { isMobile, isTablet } from 'react-device-detect';
import CustomDialog from '../custom-dialog/custom-dialog';

type TextFieldWithScanProps = TextFieldProps & {
  act: (value: string) => void;
  continuousScanning?: boolean;
  actOnEnterPressed?: boolean;
  clearOnAct?: boolean;
};

function TextFieldWithScan({
  act,
  onChange,
  disabled,
  continuousScanning,
  actOnEnterPressed,
  ...props
}: TextFieldWithScanProps) {
  const [isScanning, setIsScanning] = useState(false);
  const [value, setValue] = useState<any>(props.value);
  const [error, setError] = useState(false);

  const pattern = /^[a-zA-Z0-9.-]+$/;

  const beepSound = new Howl({
    src: ['/media/Barcode-scanner-beep-sound.mp3'],
    volume: 0.0075,
  });

  const onNewCameraScanResult = (
    newDecodedText: string,
    newDecodedResult: Html5QrcodeResult
  ) => {
    if (newDecodedText != value) {
      beepSound.play();
      setValue(newDecodedText);
    }
  };


  useEffect(() => {
    if (value.length == 0) return
    if (isScanning) {
      act(value)
      if (!continuousScanning)
        setIsScanning(false);
    } else {
      if (!actOnEnterPressed) act(value)
    }

  }, [value]);

  return (
    <>
      <TextField
        autoComplete="off"
        {...props}
        disabled={disabled}
        onChange={(e) => {
          const inputValue = e.target.value;
          setValue(inputValue);
          setError(!pattern.test(inputValue));
        }}
        value={value}
        helperText={
          error
            ? 'Only English alphanumeric characters, dots (.) and dashes (-) are allowed.'
            : ''
        }
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            act(value)
            if (actOnEnterPressed) {
              setValue("")
            }
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setIsScanning(true)}
                edge="end"
                disabled={disabled}
              >
                <QrCodeScannerIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <CustomDialog open={isScanning} fullWidth={true} onClose={() => setIsScanning(false)}>
        <DialogContent>
          <div
            style={{
              width: '100%',
            }}
          >
            {isScanning && (
              <BarcodeScanner onSuccessfullScan={onNewCameraScanResult} />
            )}
          </div>
        </DialogContent>

        <div style={{ width: '100%', textAlign: 'center' }}>
          <Button size={(isMobile && !isTablet) ? "small" : "medium"}
            sx={{ width: '70%', marginBottom: 3 }}
            color="primary"
            variant="contained"
            onClick={() => {
              setIsScanning(false);
            }}
          >
            {' '}
            Close{' '}
          </Button>
        </div>
      </CustomDialog>
    </>
  );
}

export default TextFieldWithScan;
